<template>
    <v-container>
        <v-form v-model="valid" @submit.prevent="searchUser">
            <v-text-field
                v-model="query"
                label="Cari Pengguna dengan email, nama, atau kontak"
                append-icon="mdi-magnify"
                autofocus
                class="mt-4"
                :rules="rules"
            ></v-text-field>
        </v-form>

        <user-search-result
            :users="users"
        ></user-search-result>
    </v-container>
</template>

<script>
import UserSearchResult from './components/UserSearchResult.vue'

export default {
    components: {
        UserSearchResult,
    },

    data: () => ({
        query: null,
        users: null,
        dialog: null,
        valid: null,
        rules: [
            v => !! v || 'Kolom pencarian harus diisi',
            v => v && v.length >= 7 || 'Kata kunci pencarian minimal harus 7 karakter',
        ]
    }),

    methods: {
        async searchUser() {
            if (this.valid) {
                this.users = null

                let users = await this.$api.get('user/search', {
                    params: { query: this.query },
                    loader: 'appbar'
                })

                this.users = users.data.users
            }
        },

    }
}
</script>
